import { useState } from 'react';
import { kppOk, kppOverview, type KppRow } from './logistics-api';
import { KppRejectModal } from './KppRejectModal';
import { useData } from './useData';

export function KppScreen() {
  const { data, refresh } = useData('kpp', kppOverview);
  const log = data?.log ?? null;
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  const [reject, setReject] = useState<KppRow | null>(null); // окно отклонения

  async function pass(id: number) {
    setBusy(true);
    setMsg(null);
    try {
      await kppOk(id);
      await refresh();
    } catch (e) {
      // Сверка не прошла (нет накладной/отгрузки) — охранник должен видеть причину.
      setMsg(e instanceof Error ? e.message : 'Выпуск запрещён: не прошла сверка с накладной.');
    } finally {
      setBusy(false);
    }
  }

  const hm = (at: string) => (at && at.length >= 16 ? at.slice(11, 16) : at);

  if (!log) return <p className="muted">Загрузка…</p>;

  return (
    <div className="scr">
      <div className="scr-head">
        <h2>КПП · пропуск машин</h2>
        <span className="muted">выпуск по накладным</span>
      </div>

      {msg && <p className="err">{msg}</p>}

      <div className="tablewrap glass">
        <table className="tbl card-table">
          <thead>
            <tr>
              <th>Время</th>
              <th>Груз</th>
              <th>Контракт</th>
              <th>Машина</th>
              <th>Отметка</th>
            </tr>
          </thead>
          <tbody>
            {log.map((k) => (
              <tr key={k.id} style={{ cursor: 'default' }}>
                <td data-label="Время" className="mono">
                  {hm(k.at)}
                </td>
                <td data-label="Груз">
                  <b>{k.what}</b>
                </td>
                <td data-label="Контракт" className="mono muted">
                  {k.deal_no}
                </td>
                <td data-label="Машина">{k.truck}</td>
                <td data-label="Отметка">
                  {k.ok ? (
                    <span className="chip grn">выпущено ✓</span>
                  ) : (
                    <span
                      style={{
                        display: 'inline-flex',
                        gap: 6,
                        flexWrap: 'wrap',
                        alignItems: 'center',
                      }}
                    >
                      {k.rejected ? (
                        <span className="chip red" title={k.reject_reason ?? ''}>
                          ⛔ отклонена{k.reject_reason ? ': ' + k.reject_reason : ''}
                        </span>
                      ) : null}
                      <button className="btn ghost sm" disabled={busy} onClick={() => pass(k.id)}>
                        Проверить и выпустить
                      </button>
                      {!k.rejected && (
                        <button
                          className="btn ghost sm"
                          disabled={busy}
                          onClick={() => setReject(k)}
                        >
                          Отклонить
                        </button>
                      )}
                    </span>
                  )}
                </td>
              </tr>
            ))}
            {log.length === 0 && (
              <tr>
                <td colSpan={5} className="muted">
                  Записей нет. Машины появляются здесь после отправки со склада.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {reject && (
        <KppRejectModal
          row={reject}
          onClose={() => setReject(null)}
          onDone={() => {
            setReject(null);
            refresh();
          }}
        />
      )}
    </div>
  );
}
